import { RenderChildren } from '@/node-editor/components';
import {
  getChildren,
  getRootNode,
  useSelectors,
} from '@/node-editor/store/selectors';
import { Container } from '@mui/material';
import React, { useMemo } from 'react';

export const Render = React.memo(() => {
  const selectors = useSelectors(() => ({
    getRootNode,
    getChildren,
  }));

  const rootNode = useMemo(() => selectors.getRootNode(), [selectors]);
  const children = useMemo(() => selectors.getChildren(rootNode.id), [
    selectors,
    rootNode.id,
  ]);

  return (
    <Container disableGutters maxWidth={false}>
      <RenderChildren>{children}</RenderChildren>
    </Container>
  );
});
